import React from 'react';
import { ResultCard } from '../../components/ResultCard';
import {
  kitResultTitle,
  kitWriteMessage,
  legText,
  legsIn,
  legsOut,
} from '../../../../features/operatorKits/operatorKitsUtils';

const Legs = ({ title, legs }) =>
  legs.length > 0 && (
    <div>
      <p className="text-xs font-semibold uppercase tracking-wide text-text-muted">{title}</p>
      <ul className="text-sm text-ninja-dark dark:text-white">
        {legs.map((leg) => (
          <li key={`${leg.product_id}:${leg.slot_code}:${leg.lot}`}>{legText(leg)}</li>
        ))}
      </ul>
    </div>
  );

/**
 * How the write went, as the ledger registered it: what went out, and what
 * came in. A retry that had gone through says it was not done twice.
 *
 * @param {object} props
 * @param {{kind: string, replayed: boolean, quantity: number, sku: string, toSlotCode: string, legs: object[]}} props.result
 */
export const KitResult = ({ result }) => (
  <ResultCard
    title={kitResultTitle(result)}
    testId="kit-result"
    data={{ 'data-kind': result.kind, 'data-replayed': String(result.replayed) }}
  >
    {result.replayed && (
      <p className="text-sm font-semibold text-ninja-dark dark:text-white">
        {kitWriteMessage(result.kind, { replayed: true }, { quantity: result.quantity, kitSku: result.sku }).message}
      </p>
    )}
    <Legs title="Salió" legs={legsOut(result.legs)} />
    <Legs title="Entró" legs={legsIn(result.legs)} />
  </ResultCard>
);
